<template>
  <div id='' class='gPageBorder' v-loading='loading'>

   
    <el-dialog  size='small' style="" class='gDia' :title="$t('app_cnsetting')" :visible.sync="isSetFtp">
      
      

      <el-form class='gForm'  ref="form" label-position="right" label-width="25%" :model="form" :rules="rules" style="width: 90%;">

        <el-form-item :label="$t('app_cntype')" prop="">
          <el-radio class="radio" v-model="cntype" label="0">{{$t('app_bglist')}}</el-radio>
          <el-radio class="radio" v-model="cntype" label="1">FTP</el-radio>
        </el-form-item> 

        <span v-if='cntype == 0'>
          <el-form-item :label="$t('app_filepath')" prop="path">
            <el-input v-model="form.path"></el-input>
          </el-form-item>
          <el-form-item :label="$t('app_queryudfre')" prop="frequence">
            <el-input v-model="form.frequence" @change='numchange'>
              <template slot="append">{{$t('app_hour')}}</template>
            </el-input>
          </el-form-item>
        </span>

        <span v-else>
          <el-form-item :label="'IP' + $t('app_addrandport')" prop="ip">
            <el-row>
              <el-col :span="18">
                <el-input placeholder="IP" v-model="form.ip" style="width:calc(100% - 8px);"></el-input>
              </el-col>
              <el-col :span="6">
                <el-input placeholder="Port" v-model="form.port" style="width:100%;"></el-input>
              </el-col>
            </el-row>
            
          </el-form-item>
          <el-form-item :label="'FTP' + $t('app_account')" prop="usr">
            <el-input v-model="form.usr"></el-input>
          </el-form-item>
          <el-form-item :label="'FTP' + $t('lin_global.password')" prop="psw">
            <el-input v-model="form.psw"></el-input>
          </el-form-item>
          <el-form-item :label="'FTP' + $t('app_filepath')" prop="path">
            <el-input v-model="form.path"></el-input>
          </el-form-item>
          <el-form-item :label="$t('app_queryudfre')" prop="frequence">
            <el-input v-model="form.frequence" @change='numchange'>
              <template slot="append">{{$t('app_hour')}}</template>
            </el-input>
          </el-form-item>
        </span>

        <!-- <el-form-item :label="$t('app_starttime')" prop="stt">
         
          <el-time-select
            v-model="form.stt"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00'
            }"
            :placeholder="$t('app_select')">
          </el-time-select>
        </el-form-item> -->
        
        <el-form-item label="" prop="">
          <el-button @click="isSetFtp = false">{{$t('app_cancel')}}</el-button>
          <el-button @click='save' type="primary">{{$t('app_save')}}</el-button>
        </el-form-item>
      </el-form>

      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="editMenuNameAndUrl = false">{{$t('mao_global.btn.cancel')}}</el-button>
        <el-button type="primary" @click="submitMenuEdit()">{{$t('mao_global.btn.ok')}}</el-button>
      </div> -->
    </el-dialog>
   

    <div id=''>
      <div style=''>

        <el-row>
          <el-col :span="20" class=''>
            <el-button class='gSgLeftBtn' type='primary' @click='jumpToUpload'>{{$t('app_addblfile')}}</el-button>
            <el-button class='gCtrl' type='primary' @click='setFTP'>{{$t('app_cnsetting')}}</el-button>
            
          </el-col>

          

          <!-- <el-col :span="4">
            <div class='gCtrl'>
              
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col> -->
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_filename')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>

        </el-row>
        
        
      </div>
    </div>


    <!-- <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        class='tbPoint gTopMg'
        style="width: 100%;border:none;">
        
        <el-table-column
          header-align='center'
          align='center'
          prop="name"
          :label="$t('app_filename')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="flag"
          width=''
          :label="$t('app_filetag')">
        </el-table-column>

        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</label>
          </template>
        </el-table-column> -->

        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="version"
          width='120'
          :label="$t('app_newgVer')">
        </el-table-column> -->

        <el-table-column
          header-align='center'
          align='center'
          prop="opeTime"
          width='175'
          fformatter="dateFormat"
          :label="$t('app_ulTime')">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='right'
          prop="operate"
          width='86'
          :label="$t('app_operate')">
          <template slot-scope='scope'>

            <span style='background:none;'>

            <!-- <el-button v-show="scope.row.status === '2'" type=text @click='pushApp(scope.row)'>{{$t('app_push')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_detail')" placement="top">
              <el-button v-show="true" type=text @click='toDetail(scope.row)'><i class="fa fa-chain" style=""></i></el-button>
            </el-tooltip> -->

            <!-- <el-button v-show="(scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0" type=text @click='editApp(scope.row)'>{{$t('app_edit')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button v-show="true " type=text @click='editApp(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button v-show="scope.row.status !== '1' && scope.row.status !== '2' && scope.row.isoperate === 0" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
              <el-button v-show="scope.row.status == 0 || scope.row.status == 3" @click='submitApp(scope.row)' type='text'><i class="fa fa-external-link-square" style=""></i></el-button>
            </el-tooltip> -->

            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top" v-show='scope.row.status != 1'>
              <el-button type='text' @click='deleteApp(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
            
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<style>
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}

  
    
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import mm from 'moment'
  export default{
    components: {
      MechanismSelector
    },
    data () {
      var that = this
      return {
        mechanismData: {
          callback (value) {
            that.mech = value
            that.selectChange(value)
          }
        },
        isAddFTP: false,
        sltime: '',
        cntype: '0',
        form: {
          id: '',
          ip: '',
          port: '',
          path: '',
          usr: '',
          psw: '',
          stt: '01:00',
          frequence: 0
        },
        rules: {
          stt: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          ip: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          path: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          usr: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          psw: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          frequence: [
            {type:'number', required: true, message: this.$t('app_inputNumber') + ' 1-23', trigger: 'blur' }
          ]
        },
        isSetFtp: false,
        listKey: 'launch-list',
        cerDialogVisible: false,
        cerTipDialogVisible: false,
        dvLoading: 0,
        appId: '',
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ],
        channels: [],
        srchValue: '',
        channelId: '',
        cerTipMsg: '',
        status: '',
        dvIndex: 1,
        dialogVisible: 0,
        mechanismId: window.localStorage['mechanismId'],
        selectMid: '',
        tableData: [],
        dvTableData: [],
        appTypes: [],
        appTypeValue: '',
        appStatus: [
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}],
        appStatusValue: '',
        total: 0,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: ''
      }
    },
    computed: {
      index () {
        var vl = this.$getWPage(this.listKey)
        return vl ? vl : 1
      },
      getDvStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      }
    },
    methods: {
      timeChange (vl) {
        // console.log(vl)
        this.form.stt = vl
      },
      setFTP () {
        this.loading = 1
        this.$getFTPDetail((res) => {
          this.loading = 0
          if (res.status === 200) {
            if (res.data) {
              this.isAddFTP = false
              this.form.ip = res.data.ftpAddress
              this.form.port = res.data.ftpPort
              this.form.path = res.data.ftpPath
              this.form.usr = res.data.ftpUser
              this.form.psw = res.data.ftpPwd
              this.form.frequence = res.data.updateTime
              this.form.id = res.data.id
              this.form.stt = res.data.opeTime
              // if (res.data.ftpAddress) {
              //   this.cntype = '1'
              // } else {
              //   this.cntype = '0'
              // }
            } else {
              this.isAddFTP = true
              this.form = {}
            }
            this.isSetFtp = true
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message(this.$t('app_rqsError'))
        })
      },
      numchange (vl) {
        var index = vl.indexOf('.')
        if (index > 0 || vl > 23) {
          this.$message.error($t('app_inputNumber') + ' 1-23')
        } else {
          this.form.frequence = parseInt(vl)
        }
      },
      save () {
        
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (!this.form.port && this.cntype == '1') {
              this.$message.error(this.$t('app_inputCp'))
              return
            }
            if (this.cntype == 0) {
              this.form.ip = ''
              this.form.port = ''
              this.form.usr = ''
              this.form.psw = ''
            }
            if (this.isAddFTP) {
              this.newRqs()
            } else {
              this.editRqs()
            }
          } else {
            return false
          }
        })
      },
      newRqs () {
        this.loading = 1
        var form = this.form
        this.$addFTP(form.stt ,form.ip, form.port, form.usr, form.psw, form.path, form.frequence, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.isSetFtp = false
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message(this.$t('app_rqsError'))
        })
      },
      editRqs () {
        this.loading = 1
        var form = this.form
        this.$editFTP(form.id, form.stt, form.ip, form.port, form.usr, form.psw, form.path, form.frequence, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.isSetFtp = false
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message(this.$t('app_rqsError'))
        })
      },
      pushCreateCer () {
        this.$router.push({path: "/certificate/new"})
      },
      pushUploadCer () {
        this.$router.push({path: "/certificate/upload"})
      },
      bindOperate (row) {
        //console.log(row)
        
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
      },
      getChannels () {
        this.$getChannelList(10000, 1, '','','', (res) => {
          if (res.status === 200) {
            this.channels = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      srchDevice () {
        this.getDevices()
      },
      selectDvChange (vl) {
        this.getDevices()
      },
      pageDvSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var appId = this.appId ? this.appId : ''
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
            // console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          
          this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
            console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
        
      },
      editApp (row) {
        this.$setWObj('filestEdit', {type: 1, data: row})
        this.$router.push({path: '/stfile/edit'})
      },
      pushApp (row) {
        

        this.$setWObj('pushList', {type: '13', data: row})
        this.$router.push({path: '/stfile/push'})
       
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      pageSelect (index) {
        this.$setWPage(this.listKey, index)
        this.getList()
      },
      pageDvSelect (index) {
        this.dvIndex = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      deleteApp (obj) {

        
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          console.log(obj)
          this.$delFst(obj.id, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      submitApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$verifyFst(obj.recordId, '', '1', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
          
        }, '')
      },
      cellClick (row, ev, col) {
        if (col.label && col.label === this.$t('app_operate')) {
          return
        }
      
        //console.log(row)
        
        this.toDetail(row)
        
      },
      toDetail (row) {
        // var isDetail = (row.status === '1' || row.status === '2')
        var path = '/stfile/detail'
        var key = 'stfileDetail'
        var obj = row

        // console.log('set', key, obj)

        this.$setWObj(key, obj)
        this.$router.push({path: path})
      },
      jumpToUpload () {
        /*this.loading = 1
        this.$isCer(this.mechanismId, (res) => {
          this.loading = 0
          // console.log('cer', res)
          if (!res.data) {
            this.$setWObj('editAppConfig', {type: 0})
            //this.$router.push({name: this.$t('menu.appManageSub.uploadApp')})
          } else {
            //this.$message.error(res.message)
            //this.$router.push({path: "/certificate/new"})
            this.cerTipMsg = res.message
            var vl = localStorage.cerType
            if (vl === '0') {
              // self
              this.cerDialogVisible = true
            } else {
              // other
              this.cerTipDialogVisible = true
            }
            
          }
        }, () => {
          // this.$message(this.$t('app_rqsError'))
        })*/

        this.$setWObj('filestEdit', {type: 0})
        this.$router.push({path: '/stfile/add'})
      },
      getList () {
        this.loading = 1
        var dsid = this.selectMid ? this.selectMid : '' //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        this.$fstList(this.index, this.$gRow, name, (res) => {
          
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      setInstallType (type) {
        return this.$installType[type]
      }
    },
    mounted () {
      
      //this.getChannels()
      this.getList()
      /*this.$getAppTypeList(100000000, 1, (res) => {
        if (res.status === 200) {
          this.appTypes = res.data
        } else {
          this.$message(res.message)
        }
      }, '')*/
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?4a8033c2